import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { IModal, SelectOption } from "../../stores";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import Select, { MultiValue } from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";

const AddOnForm = observer(({ show, setShowModal }: IModal) => {
  const { addOnStore, addOnOptstore } = useStores();
  const { editAddOn, saveAddOn, fetchAddOns } = addOnStore;
  const { fetchAddOnOptions, addOnOptions } = addOnOptstore;
  const [addOnTitle, setAddOnTitle] = useState(editAddOn?.addOnName ?? "");
  const [canChooseMultiple, setCanChooseMultiple] = useState(
    editAddOn?.canChooseMultiple ?? false
  );
  const [selectedOptions, setSelectedOptions] = useState<
    MultiValue<SelectOption> | undefined
  >(
    editAddOn?.addOnOptions?.map((a) => {
      return {
        label: a.addOnOption.addOnOptionName,
        value: a.addOnOptionId.toString(),
      } as SelectOption;
    })
  );

  const [isFormValid, setIsFormValid] = useState(true);
  const isEditRequest = editAddOn != null && editAddOn.addOnId > 0;

  useEffect(() => {
    if (!addOnOptions || !addOnOptions.length) fetchAddOnOptions();
  }, [addOnOptions]);

  useEffect(() => {
    const isValid =
      addOnTitle?.length > 0 &&
      selectedOptions != null &&
      selectedOptions.length > 0
        ? true
        : false;
    setIsFormValid(isValid);
  }, [addOnTitle, selectedOptions?.length]);

  const addOnOpts = useMemo(() => {
    return addOnOptions?.map((a) => {
      return {
        label: a.addOnOptionName,
        value: a.addOnOptionId.toString(),
      } as SelectOption;
    });
  }, [addOnOptions]);

  const handleAddOnOptionChange = (opts: MultiValue<SelectOption>) => {
    setSelectedOptions(opts);
  };

  const handleOnModalClose = () => {
    setSelectedOptions(undefined);
    setShowModal(false);
  };

  const submitCallback = useCallback((res: boolean) => {
    if (res) {
      handleOnModalClose();
      fetchAddOns();
      ShowAlert.Success(
        `Add-On ${isEditRequest ? "updated" : "added"} successfully.`
      );
    } else {
      ShowAlert.Error("Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    saveAddOn(
      {
        addOnId: editAddOn?.addOnId,
        addOnName: addOnTitle,
        canChooseMultiple,
        addOnOptions: selectedOptions?.map((op) => op.value),
      },
      submitCallback
    );
  };

  return (
    <Modal show={show} onHide={handleOnModalClose}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Product Add-Ons</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="addOnTitle"
              placeholder="title"
              value={addOnTitle || ""}
              onChange={(e) => setAddOnTitle(e.target.value)}
            />
            <label htmlFor="prodName">Add-On Name</label>
          </div>
          <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="canChooseMulti"
              checked={canChooseMultiple}
              onChange={(e) => setCanChooseMultiple(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="canChooseMulti">
              Enable multiple add-on option select for users
            </label>
          </div>
          <div>
            <div className="row">
              <h6>
                <span>Add-Ons Options</span>
              </h6>
            </div>
            <div>
              <Select
                defaultValue={selectedOptions}
                isMulti
                name="opts"
                options={addOnOpts}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Search or Select Options"
                onChange={handleAddOnOptionChange}
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update Add-On</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add Add-On</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default AddOnForm;
